import { gql } from '@apollo/client';

export const UPDATE_GENERIC_FILTER_PARAM = gql`
  mutation updateGenericFilterParam($input: GenericFilterParamInput) {
    updateGenericFilterParam(input: $input) {
      commandId
      correlationId
    }
  }
`;
